import TileLayer from 'ol/layer/Tile';
import XYZ from 'ol/source/XYZ';
import OSM from 'ol/source/OSM'; // Importing OSM source

import Mediator from 'gisw/Classes/Mediator';
import NodeHash from 'gisw/Widgets/NodeHash';

class BasemapManager {
  /**
   * @param {object} config
   * @param {string} config.id
   */
  constructor (config) {
    this.id = config.id;

    this.tabsDefaultBasemap = Mediator.serverData.FrontEndOption
      .tabsDefaultBasemap
      ? JSON.parse(
        Mediator.serverData.FrontEndOption.tabsDefaultBasemap.SubOptions
      )
      : null;

        console.log('Calling loadLayers');
        this.loadLayers();
        this.onExtentChange = this.onExtentChange.bind(this);
        this.isLoadingEmptyImage = false;
        Mediator.map.on('moveend', this.onExtentChange);
    }

  getDomNode () {
    if (this.domNode && !$(this.domNode).is(':empty')) {
      // Reuse created domNode for each department
      // since they have the base maps per login
      return this.domNode;
    }

    const initItems = [{ key: Mediator.serverData.urls.streetLabel }].concat(
      Mediator.serverData.EntityAerials.map(aerial => ({ key: aerial.Label }))
    );

    const baseMapBtnsWidget = new NodeHash({
      id: 'BasemapsNodeHash',
      initItems,
      className: 'ThumbnailWindow',
      createNode
    });

    baseMapBtnsWidget.itemEventListener('click', this.buttonHandler.bind(this));

    this.domNode = baseMapBtnsWidget.domNode;

    this._toggleSelectBtnCSS(this.currentBasemap);

    return this.domNode;
  }

  buttonHandler (domNode, basemapName) {
    this._toggleSelectBtnCSS(basemapName);
    this.switchBaseMap(basemapName);
  }

  getCurrentBasemap () {
    return this.currentBasemap;
  }

    async loadLayers() {
        console.log('In loadLayers');
        /** @type {Record<string, TileLayer>} */
        this.baseMapLayers = {};

    const urls = Mediator.serverData.urls;

        // Setup ESRI Raster Street Layer
        if (urls.streetLabel === 'OSM_Street') {
            this.baseMapLayers[urls.streetLabel] = new TileLayer({
                source: new OSM(),
            });
        } else {
            this.baseMapLayers[urls.streetLabel] = new TileLayer({
                source: new XYZ({
                    crossOrigin: 'anonymous',
                    transition: 0,
                    url: `${urls.streetUrl}/tile/{z}/{y}/{x}?blankTile=false`,
                    maxZoom: urls.streetMaxZoom,
                }),
            });
        };

        for (const entityAerial of Mediator.serverData.EntityAerials) {
            try {
                // Handle OpenStreetMap base layer
                if (entityAerial.AerialServer === 'osm') {
                    console.log('Creating OSM TileLayer for:', entityAerial.Label);

                    this.baseMapLayers[entityAerial.Label] = new TileLayer({
                        source: new OSM(),
                    });

                    // Handle all other cases (Typically ESRI Raster Tile Service)
                } else {
                    console.log('Creating TileLayer for:', entityAerial.Label);
                    this.baseMapLayers[entityAerial.Label] = new TileLayer({
                        source: new XYZ({
                            crossOrigin: 'anonymous',
                            transition: 0,
                            url: `${combineMapUrl(
                                entityAerial.AerialServer,
                                entityAerial.AerialServiceName
                            )}/tile/{z}/{y}/{x}?blankTile=false`,
                            maxZoom: entityAerial.MaxZoom,
                        }),
                    });
                }
            } catch (error) {
                console.error('Error creating layer for:', entityAerial.Label, error);
            }
        }

    this.switchBaseMap(urls.streetLabel);
  }

    switchBaseMap(basemap) {
        console.log('Switching to basemap:', basemap);
        const prevBasemap = this.baseMapLayers[this.currentBasemap];

    if (prevBasemap) {
      Mediator.map.removeLayer(prevBasemap);
    }

    this.currentBasemap = basemap;

    const curBasemap = this.baseMapLayers[basemap];

        if (curBasemap) {
            console.log('Adding new basemap:', basemap);
            Mediator.map.getLayers().insertAt(0, curBasemap);
        } else {
            console.warn('No basemap found for:', basemap);
        }

    this.loadEmptyCacheImage();
    updateLogo(basemap);
  }

  onExtentChange () {
    this.loadEmptyCacheImage();
  }

    loadEmptyCacheImage() {
        const curLayer = this.baseMapLayers[this.currentBasemap];
        if (!curLayer) return;

        const curZoomLevel = Mediator.map.getView().getZoom();
        const maxZoom = 19;

        if (curZoomLevel > maxZoom && this.isLoadingEmptyImage === false) {
            this.isLoadingEmptyImage = true;
            Mediator.map.getView().setZoom(maxZoom);

      setTimeout(
        function () {
          Mediator.map.getView().setZoom(curZoomLevel);
        }, 50);
      setTimeout(
        function () {
          this.isLoadingEmptyImage = false;
        }.bind(this), 500);
    }
  }

  switchBaseMapForTab () {
    if (!this.tabsDefaultBasemap) {
      return;
    }

    const aerials = Mediator.serverData.EntityAerials;
    const curTabId = Mediator.getCurrentTabID();
    const targetId = this.tabsDefaultBasemap[curTabId];

    if (!targetId) {
      this.buttonHandler(null, Mediator.serverData.urls.streetLabel);
      return;
    }

    for (let i = 0; i < aerials.length; i++) {
      if (aerials[i].ID === targetId) {
        this.buttonHandler(null, aerials[i].Label);
        return;
      }
    }
  }

  isExceedMaxZoom () {
    let tileMaxZoom =
    Mediator.serverData.urls.streetLabel === this.currentBasemap
      ? Mediator.serverData.urls.streetMaxZoom : null;

    tileMaxZoom = tileMaxZoom || Mediator.serverData.EntityAerials
      .find(a => a.Label === this.currentBasemap)?.MaxZoom;

    const curZoom = Mediator.map.getView().getZoom();
    return curZoom > tileMaxZoom;
  }

  /**
   * @private
   * @param {string} toolName
   */
  _toggleSelectBtnCSS (toolName) {
    $('.ThumbnailGrid > button', this.domNode).removeClass('selected');
    $('.ThumbnailGrid > [id=\'' + toolName + '\']', this.domNode).addClass(
      'selected'
    );
  }
}

function createNode (param) {
  const thumbnailGridDiv = document.createElement('div');
  thumbnailGridDiv.classList.add('ThumbnailGrid');

  const button = document.createElement('button');
  button.id = param.key;
  button.title = param.key;
  button.className = 'Layer' + param.key + 'Btn';

  const label = document.createElement('label');
  label.textContent = param.key;
  label.title = param.key;

  thumbnailGridDiv.append(button, label);

  return thumbnailGridDiv;
}

/**
 * @param {string} mapserver
 * @param {string} mapservicename
 */
function combineMapUrl (mapserver, mapservicename) {
  if (
    mapservicename.startsWith('http://') ||
    mapservicename.startsWith('https://')
  ) {
    return mapservicename;
  }

  return (
    'https://' +
    mapserver +
    '.gworks.com/arcgis/rest/services/' +
    mapservicename +
    '/MapServer'
  );
}

/**
 * Also updates `BottomRightMenu`'s text color
 * @param {string} basemap
 */
function updateLogo (basemap) {
  switch (basemap) {
    case 'Street':
    case 'Light Gray':
    case 'Topo':
    case 'Terrain':
    case 'ESRI_Street':
      $('#logoImage').attr('src', 'Content/shared/images/gWorks_md.png');

      if (Mediator.bottomRightMenu) {
        Mediator.bottomRightMenu.toggleIsLightBasemap(true);
      }

            break;
    case 'OSM_Street':
        $('#logoImage').attr('src', 'Content/shared/images/gWorks_md.png');

        if (Mediator.bottomRightMenu) {
            Mediator.bottomRightMenu.toggleIsLightBasemap(true);
            Mediator.bottomRightMenu.toggleOSMCredit(true);
        }

        break;
    default:
        $('#logoImage').attr('src', 'Content/shared/images/gWorks_white_md.png');

      if (Mediator.bottomRightMenu) {
        Mediator.bottomRightMenu.toggleIsLightBasemap(false);
      }

      break;
  }
}

export default BasemapManager;
